import { fetchEventSource } from '@microsoft/fetch-event-source'

import { getToken } from '@/lib/token'
import type { StreamEvent } from '@/api/types'

export interface StreamHandle {
  abort: () => void
  done: Promise<void>
}

export interface StreamMessageRequest {
  content: string
  display_content?: string
  attachments?: string[]
}

export function streamTurn(
  sessionId: string,
  body: StreamMessageRequest,
  onEvent: (ev: StreamEvent) => void,
  onError: (err: unknown) => void,
): StreamHandle {
  const token = getToken()
  const ctrl = new AbortController()
  const done = fetchEventSource(`/v1/sessions/${sessionId}/messages`, {
    method: 'POST',
    headers: {
      Accept: 'text/event-stream',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
    signal: ctrl.signal,
    openWhenHidden: true,
    async onopen(response) {
      if (!response.ok) {
        throw new Error(`SSE open failed: ${response.status}`)
      }
    },
    onmessage(msg) {
      if (!msg.event || msg.event === 'heartbeat') {
        return
      }

      try {
        const data = JSON.parse(msg.data)
        onEvent({ event: msg.event, data } as StreamEvent)
      } catch (err) {
        onError(err)
        throw err
      }
    },
    onerror(err) {
      onError(err)
      throw err
    },
  })

  return {
    abort: () => ctrl.abort(),
    done,
  }
}
